var render = function render(){var _vm=this,_c=_vm._self._c;return _c('VStepperContent',_vm._g(_vm._b({attrs:{"step":_vm.step}},'VStepperContent',_vm.$attrs,false),_vm.$listeners),[_c('div',{staticClass:"mb-4"},[(_vm.title)?_c('h2',{staticClass:"brand-blue--text",domProps:{"textContent":_vm._s(_vm.title)}}):_vm._e()]),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }